<template>
  <div class="navigation footer">
    <GrootTwsFooter
      :address="address"
      :customLinks="customLinks"
      :navigationLinks="filteredNavigationLinks" />
  </div>
</template>

<script>
import i18n from '@/i18n'
import { applyReactInVueWithOptions } from '@/utils/react.utils'
import { isLoggedIn } from '@/utils/user.utils'
import { GrootTwsFooter } from 'groot-components'

export default {
  components: {
    GrootTwsFooter: applyReactInVueWithOptions(GrootTwsFooter)
  },
  data () {
    return {
      address: {
        companies: [
          {
            name: 'Telia Sverige AB',
            box: '169 94',
            city: 'Solna',
            orgNumber: '556430-0142'
          },
          {
            name: 'Skanova AB',
            box: '169 03',
            city: 'Solna',
            orgNumber: '556446-3734'
          }
        ]
      },
      customLinks: [{
        text: this.$t('footer.cookies'),
        href: 'javascript:void(0)',
        onClick: () => this.cookieSettingsScriptInit()
      }],
      categories: [
        {
          heading: this.$t('footer.about-us'),
          sub_categories: [
            {
              text: this.$t('footer.sustainability'),
              href: '/articles/hallbarhet',
              public: true
            },
            {
              text: this.$t('footer.security'),
              href: '/articles/sakerhet',
              public: true
            },
            {
              text: this.$t('footer.campaigns'),
              href: '/private/Aktuella-kampanjer',
              public: false
            },
            {
              text: this.$t('footer.reference-offer'),
              href: '/articles/referenserbjudande',
              public: true
            },
            {
              text: this.$t('footer.wholesale-in-nordics'),
              href: 'https://business.teliacompany.com/global-solutions/wholesale',
              public: true
            },
            {
              text: this.$t('footer.work-at-telia'),
              href: 'https://www.teliacompany.com/en/careers/open-positions',
              public: true
            },
            {
              text: this.$t('footer.contractors'),
              href: '/private/vara-entreprenorer',
              public: false
            }
          ]
        },
        {
          heading: this.$t('footer.network-changes'),
          sub_categories: [
            {
              text: this.$t('footer.station-modernization'),
              href: '/private/stationsmodernisering',
              public: false
            },
            {
              text: this.$t('footer.network-of-future'),
              href: '/public/framtidens-nat',
              public: true
            },
            {
              text: this.$t('footer.network-and-tools'),
              href: '/natinformation/natforandringar',
              public: true
            },
            {
              text: this.$t('footer.delivery-times-fiber'),
              href: '/natinformation/Leveranstider-Fiber',
              public: true
            },
            {
              text: this.$t('footer.disturbances-in-telecommunications'),
              href: '/articles/information-koppar-fel',
              public: true
            },
            {
              text: this.$t('footer.market-consultations'),
              href: '/samrad',
              public: false
            }
          ]
        },
        {
          heading: this.$t('footer.contact'),
          sub_categories: [
            {
              text: this.$t('footer.contact-us'),
              href: '/kontakt',
              public: true
            },
            {
              text: this.$t('footer.private-individuals'),
              href: 'https://natet.telia.se',
              public: true
            },
            {
              text: this.$t('footer.property-owners'),
              href: 'https://natet.telia.se',
              public: true
            },
            {
              text: this.$t('footer.network-owners'),
              href: '/articles/natagare',
              public: true
            }
          ]
        },
        {
          heading: this.$t('footer.your-integrity'),
          sub_categories: [
            {
              text: this.$t('footer.our-privacy-policy'),
              href: '/articles/integritetspolicy',
              public: true
            },
            {
              text: this.$t('footer.our-cookie-policy'),
              href: '/articles/cookiepolicy',
              public: true
            },
            {
              text: this.$t('footer.data-processing-agreement'),
              href: '/private/personuppgiftsbitradesavtal',
              public: false
            },
            {
              text: this.$t('footer.order-registry-extract'),
              href: '/public/var-integritetspolicy/individuella-rattigheter',
              public: false
            }
          ]
        }
      ]
    }
  },
  computed: {
    filteredNavigationLinks () {
      return this.categories
        .map((category) => {
          const visibleLinks = category.sub_categories.filter(
            (link) => link.public || isLoggedIn()
          )
          if (visibleLinks.length > 0) {
            return {
              heading: category.heading,
              links: visibleLinks.map((link) => ({
                text: link.text,
                href: this.getLocalisedHref(link.href)
              }))
            }
          }
          return null
        })
        .filter(Boolean)
    }
  },
  methods: {
    cookieSettingsScriptInit () {
      // @ts-ignore
      window.OneTrust?.ToggleInfoDisplay?.()
    },
    getLocalisedHref (href) {
      if (!href || !href.startsWith('/')) {
        return href
      }
      return i18n.locale === 'en' ? `/en${href}` : href
    }
  }
}
</script>
